import axios from "axios";
import userData from "@/plugins/userData";
import Highcharts from "highcharts";
import moment from "moment";

export default {
  name: "DashboardPage",
  mixins: [userData],
  data() {
    return {
      isLoading: false,
      dataTerinput: 0,
      jumlahRelawan: 0,
      jumlahTarget: 0,
      jumlahPendukung: 0,
      terinputHarian: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      axios
        .get("/dashboard", {
          headers: {
            "X-Token": this.userToken,
          },
        })
        .then((response) => {
          this.dataTerinput = response.data.terinput || 0;
          this.jumlahRelawan = response.data.relawan || 0;
          this.jumlahTarget = response.data.target || 0;
          this.jumlahPendukung = response.data.pendukung || 0;
          this.terinputHarian = response.data.tren_terinput || [];
          
          this.$nextTick(() => {
            this.renderBarDaily();
          });
          
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Dashboard error:", error);
        });
    },

    renderBarDaily() {
      if (!this.$refs.barDaily) return;

      const chartData = this.terinputHarian.map((data) => ({
        name: this.dateShortFormat(data.tanggal),
        y: parseInt(data.jumlah) || 0,
      }));

      // Determine theme colors for chart (light/dark mode support)
      const isDark = document.documentElement.classList.contains("dark");
      const textColor = isDark ? "#cbd5e1" : "#475569";
      const gridColor = isDark ? "#334155" : "#e2e8f0";

      Highcharts.chart(this.$refs.barDaily, {
        chart: {
          type: "spline",
          backgroundColor: "transparent",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Timeline Perolehan Dukungan",
          style: {
            color: isDark ? "#ffffff" : "#1e293b",
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              color: textColor,
            },
          },
          lineColor: gridColor,
          tickColor: gridColor,
        },
        yAxis: {
          title: {
            text: "Data Terinput",
            style: {
              color: textColor,
            },
          },
          labels: {
            style: {
              color: textColor,
            },
          },
          gridLineColor: gridColor,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          backgroundColor: isDark ? "#1e293b" : "#ffffff",
          style: {
            color: isDark ? "#ffffff" : "#1e293b",
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              style: {
                color: textColor,
                textOutline: "none",
              },
            },
          },
        },
        series: [
          {
            name: "Data Terinput",
            data: chartData,
            color: "#f59c1a", // brand orange
          },
        ],
      });
    },

    dateShortFormat(dateTime) {
      return moment(dateTime).format("DD-MM-YY");
    },
  },
};
